/**
 * JS inteface for the Chat tool.
 */
window.diy = window.diy || {};
window.diy.editor = window.diy.editor || {};
window.diy.editor.chat = window.diy.editor.chat || {};
(function() {
    var initParams, initIsDone = false, sessionIsDone = false;

    // possible operator statuses //
    this.OPERATOR_STATUS_AVAILABLE = 'online';
    this.OPERATOR_STATUS_OFFLINE = 'offline';

    // Private utils //
    var createCustomEvent = function (name, params) {
        var event;
        try {
            event = new CustomEvent(name, params);
        } catch (err) { // IE and old Safari, and maybe some mobiles
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, false, false, params.detail);
        }
        return event;
    };
    var sessionInit = function (callback) {

        // don't create the session twice //
        if (sessionIsDone) {
            callback(true);
            return;
        }

        var initEvent = createCustomEvent('oneandone.inproductchat.init', {
            'detail': {
                'market': initParams['market'],
                'contractId': initParams['contractId'],
                'message': initParams['agentMessage'],
                'client': initParams['client'],
                'concern': initParams['concern'],
                'callback': function (data) {

                    // determine if initialization was successful //
                    var initStatus = false;
                    if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                        initStatus = data.result.status;
                    }

                    // if this succeeded then the session is ready for chatting //
                    if (initStatus) {
                        sessionIsDone = true;
                    }

                    callback(initStatus);
                }
            }
        });
        document.dispatchEvent(initEvent);
    };

    /**
     * Includes and bootstraps the 1and1 chat library.
     *
     * @param params
     * @param callback
     */
    this.init = function (params, callback) {
        var anchorElement, script;

        // don't initialize twice //
        if (initIsDone) {
            sessionInit(callback);
            return;
        }

        initParams = params;

        // initialize the 1and1 chat API //
        document.addEventListener('oneandone.inproductchat.loaded', function (evt) {
            initIsDone = true;

            sessionInit(callback);
        });
        anchorElement = document.getElementsByTagName('head')[0];
        script = document.createElement("script");
        script.src = params['url'];
        anchorElement.appendChild(script);
    };

    /**
     * Checks if any operator is available to chat.
     *
     * @param callback
     */
    this.checkAvailability = function (callback) {

        sessionInit (function (succeeded) {
            if (!succeeded) {
                callback(diy.editor.chat.OPERATOR_STATUS_OFFLINE);
                return;
            }

            var availEvent = createCustomEvent('oneandone.inproductchat.checkAvailability', {
                'detail': {
                    'callback': function (data) {
                        var availStatus = false;
                        if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                            availStatus = data.result.status;
                        }

                        callback((availStatus === true)
                                ? diy.editor.chat.OPERATOR_STATUS_AVAILABLE
                                : diy.editor.chat.OPERATOR_STATUS_OFFLINE
                        );
                    }
                }
            });
            document.dispatchEvent(availEvent);
        });
    };

    /**
     * Opens the chat window.
     */
    this.startChat = function () {
        sessionInit (function (succeeded) {
            if (!succeeded) {
                return;
            }

            var startEvent = createCustomEvent('oneandone.inproductchat.start', {
                'detail': {
                    'callback': function (data) {
                        var startStatus = false;
                        if (data && data.hasOwnProperty('result') && data.result.hasOwnProperty('status')) {
                            startStatus = data.result.status;
                        }
                    }
                }
            });
            document.dispatchEvent(startEvent);

            //TODO: find out if we need or not to reinit the session after starting the chat...
            //sessionIsDone = false;// discard this session as it will be consumed with the chat instance //
        });
    };

    /**
     * Combo method - combines init and start
     * @param params
     */
    this.triggerChat = function (params) {
        if (initIsDone === false) {
            this.init(
                params,
                function(succeeded) {
                    if (succeeded) {
                        diy.editor.chat.startChat();
                    }
                }
            );
        } else {
            this.startChat();
        }
    };

    return this;

}).call(diy.editor.chat);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/js/chat/1and1.js
 ** module id = 926
 ** module chunks = 0
 **/